<template lang="pug">
  app-card
    app-card-header(:class="{'selectedCategory': selected}" )
      v-icon.i-mt(v-if="selected" color="green") 
        | check_box
      v-icon.i-mt(v-else) 
        | check_box_outline_blank
      app-card-title(v-html="title")
    app-card-body(:class="{'selectedCategory': selected}" )
      slot
</template>

<script>
export default {
  name: "card-toggle",

  props: {
    title: [String, Number],
    selected: [Boolean, Object]
  }
}
</script>

<style scoped>
  .i-mt {
    margin-top:-10px;
    padding-right: 10px;
    float:left;
  }
</style>